<template>
  <div :style="css">
    <Loading v-if="loading" />

    <v-sheet
      v-else-if="item.hours && item.team"
      color="#FAFAFA"
      class="py-10 py-sm-12 py-md-14 py-lg-16 overflow-hidden"
    >
      <v-container>
        <PagesTitle :mod="mod">Horários de Atendimento</PagesTitle>

        <v-row justify="center" class="mx-0 mx-sm-n3 mt-10">
          <v-col cols="12" lg="10">
            <v-row justify="center" class="relative items">
              <img src="/img/bg/vertical.png" class="bg-vertical" />
              <img src="/img/bg/horizontal.png" class="bg-horizontal" />

              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  align-center
                  justify-center
                  page-color-primary
                  px-5
                  py-md-16 py-10
                  relative
                  item
                "
                height="100%"
              >
                <div class="relative item-caption px-5 px-md-16">
                  <div
                    class="
                      white--text
                      text-h5 text-md-h4
                      justify-center
                      font-weight-medium
                      d-flex
                      item-title
                    "
                  >
                    <div class="relative">
                      <v-icon color="white" size="30"> far fa-clock </v-icon>
                    </div>
                    <span class="ml-2"> Horários </span>
                  </div>

                  <div
                    v-html="item.hours"
                    class="text-md-h6 text-body-1 white--text item-text mt-5"
                  ></div>
                </div>
              </v-col>

              <v-col
                cols="12"
                md="6"
                class="
                  d-flex
                  align-center
                  justify-center
                  page-color-secondary
                  lighten-2
                  px-5
                  py-md-16 py-10
                  relative
                  item
                "
                height="100%"
              >
                <div class="item-caption px-5 px-md-16">
                  <div
                    v-html="item.team"
                    class="text-md-h4 text-h6 page-color-darken--text item-text"
                  ></div>
                  <div class="d-flex justify-center mt-4">
                    <v-btn
                      v-if="item.whatsapp"
                      :href="getWhatsappLinkFromPhone(item.whatsapp)"
                      height="44px"
                      depressed
                      color="page-color-darken"
                      class="white--text px-5 text-none rounded-lg"
                    >
                      <v-icon>fa-whatsapp</v-icon>
                      <span class="ml-2 text-body-1">WhatsApp</span>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import Loading from "../widgets/Loading.vue";
import PagesTitle from "../widgets/PagesTitle.vue";

const _config = {
  mod: "pages-informations-contacts",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    item: {},
  }),
  computed: {
    css() {
      return {
        "--page-color-primary": this.colors[0],
        "--page-color-secondary": this.colors[1],
        "--page-color-darken": this.colors[2],
      };
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style lang="scss" scoped>
.page-color-primary {
  background-color: var(--page-color-primary) !important;
}
.page-color-secondary {
  background-color: var(--page-color-secondary) !important;
}
.page-color-darken--text {
  color: var(--page-color-darken) !important;
}
.page-color-darken {
  background-color: var(--page-color-darken) !important;
}
.items {
  .bg-horizontal {
    position: absolute;
    right: -30px;
    top: -30px;
  }

  .bg-vertical {
    bottom: -30px;
    left: -30px;
    position: absolute;
  }

  .item {
    &:nth-child(odd) {
      border-radius: 18px 0 0 18px;
      @media screen and (max-width: 960px) {
        border-radius: 18px 18px 0 0;
      }
    }

    &:nth-child(even) {
      border-radius: 0 18px 18px 0;
      @media screen and (max-width: 960px) {
        border-radius: 0 0 18px 18px;
      }
    }
  }
}
</style>
